import translateService from './../services/translate.service'
import dictionary from '@/languages'
import { getLocale } from '@/modules/locale/locale'

const translateKey = (key, ...params) => {
  if (!key) {
    return ''
  }

  const locale = getLocale()

  return translateService.translate(dictionary, locale, key, params)
}

export default translateKey
